export default __webpack_public_path__ + "static/media/002-with-ball.6754016d.png";